import { render, staticRenderFns } from "./FamousForm.vue?vue&type=template&id=0843cfc4&"
import script from "./FamousForm.vue?vue&type=script&lang=js&"
export * from "./FamousForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports